"use client";

import { useProfile } from "@/context/useProfileProps";
import { useInvalidateQuery } from "@/hooks/useInvalidateQuery";
import {
  HEADER_QUERY_KEY,
  PROFILE_QUERY_KEY,
  PROFILE_STATS_QUERY_KEY,
  VALIDATE_PROFILE_QUERY_KEY,
} from "@/lib/queryKeys";
import { default as dynamic } from "next/dynamic";
import React, { useEffect, useState } from "react";

import {
  ApopType,
  L1ApopWrapperProps,
} from "@/components/profile/l1Card/types";

// import { ApopType, L1ApopWrapperProps } from "../../../../types";

const Apop = dynamic(
  () =>
    import("@monsterindia/l1-apop").then((mod) => {
      return mod.Apop as unknown as React.FC<ApopType>;
    }),
  {
    ssr: false,
  },
);

const L1ApopWrapper = ({
  data,
  removeL1Card,
  showL1ApopOnEvent,
}: L1ApopWrapperProps) => {
  const { handleEventTracking } = useProfile();
  const actionType = data?.actionType ?? "";
  const [showModal, setShowModal] = useState(showL1ApopOnEvent);
  const [actionTypeState, setActionTypeState] = useState(actionType as string);

  const invalidateQuery = useInvalidateQuery();

  useEffect(() => {
    if (actionType && typeof actionType === "string") {
      setActionTypeState(actionType);
    }
  }, [actionType]);

  useEffect(() => {
    if (showL1ApopOnEvent) {
      setShowModal(true);
    }
  }, [showL1ApopOnEvent]);

  const closeApop = () => {
    setShowModal(false);
    setActionTypeState("");

    if (typeof window.MessageHandler?.postMessage === "function") {
      window.MessageHandler.postMessage(
        JSON.stringify({
          type: "PROFILE_L1APOP_CLOSE",
        }),
      );
    }
  };

  const onApopComplete = () => {
    removeL1Card();

    if (typeof window.MessageHandler?.postMessage === "function") {
      window.MessageHandler.postMessage(
        JSON.stringify({
          type: "PROFILE_L1APOP_COMPLETE",
        }),
      );
    }
  };

  const onCTAHandler = (ctaType: string) => {
    if (ctaType === "BASIC_DETAILS") {
      // if name changes, the name in header should also change
      invalidateQuery(HEADER_QUERY_KEY);
    }
    invalidateQuery(PROFILE_QUERY_KEY);
    // for profile score
    invalidateQuery(PROFILE_STATS_QUERY_KEY);

    invalidateQuery(VALIDATE_PROFILE_QUERY_KEY);
  };

  return (
    <>
      <Apop
        openApop={showModal}
        closeApop={closeApop}
        type={actionTypeState}
        data={data}
        showEmailVerification={false}
        onCTA={onCTAHandler}
        onApopComplete={onApopComplete}
        isRecaptchaEnabled={
          window?._siteProps_?.propertiesMap?.recaptchaV2Switch &&
          window._siteProps_.propertiesMap.recaptchaV2Switch === "true"
            ? true
            : false
        }
        handleEventTracking={handleEventTracking}
      />
    </>
  );
};

export default L1ApopWrapper;
